export type BlogArticleProps = {
  blogArticles?: any
  supportingData?: {
    home?: {
      Algorithm?: {
        value: string
      }
    }
  }
  connectedContentPillar?: {
    fields: {
      category: string
      slug: string
    }
  }
  title?: string
  limit?: number
  showAsCarousel?: boolean
}

export type ArticleItem = {
  fields: {
    heroImage?: object
    seoPanel?: { fields?: { description?: string } }
    title?: string
    shortDescription?: string
    tags?: string[]
    slug?: string
    publishedDate?: string
  }
}

type SortOrder = 'asc' | 'desc'

export type TransformedArticle = {
  picture: object
  description: string
  title: string
  tags: string[]
  url: string
  publishedDate?: Date
}

export function articleTransformer(articles: ArticleItem[] | undefined): TransformedArticle[] {
  return articles && articles.length
    ? articles.map((item: ArticleItem): TransformedArticle => ({
        picture: item.fields?.heroImage || {},
        description: item.fields?.shortDescription || item.fields?.seoPanel?.fields?.description || '',
        title: item.fields?.title || '',
        tags: item.fields?.tags || [],
        url: '/connected/' + (item.fields?.slug || ''),
        publishedDate: item.fields?.publishedDate ? new Date(item.fields.publishedDate) : undefined,
      }))
    : []
}

export function sortArticles(
  transformedArticles: TransformedArticle[] | undefined,
  sortOrder: SortOrder = 'desc',
): TransformedArticle[] {
  return transformedArticles && transformedArticles.length
    ? transformedArticles.sort((a, b) => {
        const dateA = a.publishedDate?.getTime() ?? 0
        const dateB = b.publishedDate?.getTime() ?? 0

        if (sortOrder === 'asc') {
          return dateA - dateB
        } else {
          return dateB - dateA
        }
      })
    : []
}
